import { apiCall } from "./Interceptor";

const BID_GENERATOR_PLACE = "/bidding/generator/place";
const BIDS_RECEIVED_GENERATOR = "/bidding/generator/received";
const BIDS_LIST = "/bidding/generator/placedAgainstConsumer";
const BIDS_RECEIVED = "/bidding/generator/generator-capacity-bid-details";
const update_status = "/bidding/generator/updateStatus";
const CONNECTION_DETAILS = "/bidding/generator/bid-comparison";
const BIDS_PLACED_GENERATOR ="/bidding/generator/bid-placed";
const PUSH_TRADE_CONNECT_GENERATOR = "/bidding/generator/push-trade-connect";
const PUSH_REJECT_CONSUMER = "/bidding/consumer/rejectPush";
const PUSH_REJECT_GENERATOR = "/bidding/generator/rejectPush";

const placeBidGenerator = async (data) => {
    const response = await apiCall.post(BID_GENERATOR_PLACE,data);
    return response;
}

const getReceivedBidsGenerator = async (id,history) => {
    const response = await apiCall.get(`${BIDS_RECEIVED_GENERATOR}?capacityId=${id}&isHistory=${history}`);
    return response;
}
const getPlacedBidsGenerator = async (id) => {
    const response = await apiCall.get(`${BIDS_PLACED_GENERATOR}?capacityId=${id}`);
    return response;
}
const getBidsListByConCapacityId = async (genId,conId) => {
    const response = await apiCall.get(`${BIDS_LIST}?capacityGeneratorId=${genId}&capacityConsumerId=${conId}`);
    return response;
}

const getReceivedBidsListByGenCapacityId = async (genCapId,bidId) => {
    const response = await apiCall.get(`${BIDS_RECEIVED}?generatorCapacityId=${genCapId}&bidId=${bidId}`);
    return response;
}

const updateConnectionStatus = async (data) => {
    const response = await apiCall.patch(update_status,data);
    return response;
}

const getConnectionDetails = async (conId,genId) => {
    const response = await apiCall.get(`${CONNECTION_DETAILS}?capacityConsumerId=${conId}&capacityGeneratorId=${genId}`);
    return response;
}

const pushToTradeConnectFromGenRole = async (data) => {
    const response = await apiCall.put(PUSH_TRADE_CONNECT_GENERATOR,data);
    return response;
}

const bidRequestRejectConsumer = async (id) => {
    const response = await apiCall.get(`${PUSH_REJECT_CONSUMER}?id=${id}`);
    return response;
}

const bidRequestRejectGenerator= async (id) => {
    const response = await apiCall.get(`${PUSH_REJECT_GENERATOR}?id=${id}`);
    return response;
}

export default {
    placeBidGenerator,
    getReceivedBidsGenerator,
    getBidsListByConCapacityId,
    getReceivedBidsListByGenCapacityId,
    updateConnectionStatus,
    getConnectionDetails,
    getPlacedBidsGenerator,
    pushToTradeConnectFromGenRole,
    bidRequestRejectGenerator,
    bidRequestRejectConsumer
};
